import script from "./AddressForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AddressForm.vue?vue&type=script&setup=true&lang=js"

import "./AddressForm.vue?vue&type=style&index=0&id=219004ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-219004ee"]])

export default __exports__